<template>
    <div class="px-2 text-center bg-transparent py-14">
        <main v-if="$slots.image" class="inline-block mx-auto text-gray-500 dark:text-zinc-100">
            <slot name="image"></slot>
        </main>
        <header v-if="$slots.title" class="mt-6 text-2xl font-semibold dark:text-zinc-100">
            <slot name="title"></slot>
        </header>
        <div class="text-gray-700 dark:text-zinc-300">
            <slot></slot>
        </div>
    </div>
</template>
